<template>
  <v-container class="checkout-page">
    <v-row :class="breakpoint !== 'xs' ? 'checkout-page__back mt-10 mr-0' : 'checkout-page__back-mobile mt-2 mr-0'" justify="end">
      <v-btn to="/pricing" text color="#3badff">
        <v-icon class="checkout-page__back-icon">mdi-arrow-left</v-icon>
        <span class="checkout-page__back-text">Volver</span>
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card :class="breakpoint !== 'xs' ? 'checkout-page__card pa-4' : 'checkout-page__card-mobile elevation-0'">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h1 :class="`${ breakpoint !== 'xs' ? 'checkout-page__title' : 'checkout-page__title-mobile'} text-center`">Revisa y confirma tu compra</h1>
              </v-col>
            </v-row>

            <v-row justify-md="space-between">
              <!-- Detalles de compra -->
              <v-col class="summary" cols="12" md="6">
                <!-- Producto -->
                <v-card :class="breakpoint !== 'xs' ? 'summary__card' : 'summary__card-mobile--titles mb-5'">
                  <v-container>
                    <v-row class="py-4 px-6" justify="space-between" align="center">
                      <span :class="breakpoint !== 'xs' ? 'summary__text' : 'summary__text-mobile mx-auto text-center'">Resumen de compra</span>
                      <span :class="breakpoint !== 'xs' ? 'summary__product' : 'summary__product-mobile mx-auto text-center'">{{ selectedPack.name }}</span>
                    </v-row>
                  </v-container>
                </v-card>

                <!-- Desglose -->
                <v-card :class="breakpoint !== 'xs' ? 'summary__card' : 'summary__card-mobile mb-5'">
                  <v-container>
                    <v-row class="summary__item" justify="space-between">
                      <span class="summary__text">Subtotal</span>
                      <span class="summary__text">{{ formattedTotals.subtotal }}</span>
                    </v-row>

                    <v-divider v-if="totals.discount && totals.discount.amount > 0" class="summary__divider" />

                    <v-row v-if="totals.discount && totals.discount.amount > 0" class="summary__item" justify="space-between">
                      <span class="summary__text">Total descuento</span>
                      <span class="summary__text summary__text--highlight">- {{ formattedTotals.discount }}</span>
                    </v-row>

                    <v-divider class="summary__divider" />

                    <v-row class="summary__item" justify="space-between" v-if="selectedPack.currencyCode === 'CLP'">
                      <span class="summary__text summary__text--small">Total IVA 19%</span>
                      <span class="summary__text summary__text--small">{{ formattedTotals.iva }}</span>
                    </v-row>
                    

                    <v-divider class="summary__divider summary__divider--total" />

                    <v-row class="summary__item" justify="space-between">
                      <span class="summary__text summary__text--big">Total a pagar</span>
                      <span class="summary__text  summary__text--big">{{ formattedTotals.total }}</span>
                    </v-row>
                  </v-container>
                </v-card>

                <!-- Código descuento -->
                <v-row class="summary__item summary__item--dense" v-if="breakpoint !== 'xs'">
                  <v-card class="summary__card grow">
                    <v-container class="d-flex align-center">
                      <span class="summary__text">Código dcto.</span>
                      <v-text-field
                        v-model="discountCode"
                        class="summary__code-input mx-2 my-0 align-self-end"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-container>
                  </v-card>
                  <v-btn
                    class="summary__btn ml-4"
                    @click="onValidateDiscount"
                    dark
                    x-large
                  >
                    VALIDAR
                  </v-btn>
                </v-row>
                <v-row class="summary__item summary__item py-2" v-else>
                  <v-card class="summary__card-mobile grow">
                    <v-col cols="12" class="summary__text pb-0 ">
                      <span class="ma-0">Código dcto.</span>
                    </v-col>
                    <v-row justify="center" align="center">
                      <v-col cols="12" class="d-flex d-flex-row my-3">
                        <v-text-field
                          v-model="discountCode"
                          class="summary__code-input-mobile mx-2"
                          dense
                          filled
                        >
                        </v-text-field>
                        <v-btn
                          class="summary__btn-mobile mx-2"
                          @click="onValidateDiscount"
                          dark
                        >
                          VALIDAR
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
              </v-col>

              <!-- Detalles de pago -->
              <v-col class="document" cols="12" md="6">
                <!-- Selección tipo documento -->
                <v-card :class=" breakpoint !== 'xs' ? 'document__card' : 'document__card-mobile'">
                  <v-container>
                    <v-row class="py-4 px-6">
                      <v-radio-group
                        v-model="document.type"
                        row
                      >
                        <span class="document__option d-flex">
                          <span class="document__option-label">Factura</span>
                          <v-radio
                            color="#3BADFF"
                            class="document__option-btn"
                            value="invoice"
                          ></v-radio>
                        </span>

                        <span class="document__option d-flex" v-if="currency !== 'USD'">
                          <span class="document__option-label">Boleta</span>
                          <v-radio
                            color="#3BADFF"
                            class="document__option-btn"
                            value="receipt"
                          ></v-radio>
                        </span>
                      </v-radio-group>
                    </v-row>
                  </v-container>
                </v-card>

                <!-- Si Factura -->
                <template v-if="document.type === 'invoice'">
                  <p :class="breakpoint !== 'xs' ? 'document__text' : 'document__text-mobile text-center'">
                    Ingresa tus datos para confirmar tu compra
                  </p>
                  <v-text-field
                    v-model="invoiceForm.businessName"
                    :class="breakpoint !== 'xs' ? 'invoice-form__input' : 'invoice-form__input-mobile'"
                    placeholder="Razón social"
                    background-color="white"
                    color="#3BADFF"
                    :error-messages="businessNameErrors"
                    filled
                    @input="$v.invoiceForm.businessName.$touch()"
                    @blur="$v.invoiceForm.businessName.$touch()"
                  />
                  <v-text-field
                    v-if="selectedPack.currencyCode === 'CLP'"
                    v-model="invoiceForm.rut"
                    :class="breakpoint !== 'xs' ? 'invoice-form__input' : 'invoice-form__input-mobile'"
                    placeholder="RUT"
                    background-color="white"
                    color="#3BADFF"
                    :error-messages="rutErrors"
                    filled
                    @input="$v.invoiceForm.rut.$touch()"
                    @blur="$v.invoiceForm.rut.$touch()"
                  />
                  <v-text-field
                    v-model="invoiceForm.address"
                    :class="breakpoint !== 'xs' ? 'invoice-form__input' : 'invoice-form__input-mobile'"
                    placeholder="Dirección"
                    background-color="white"
                    color="#3BADFF"
                    :error-messages="addressErrors"
                    filled
                    @input="$v.invoiceForm.address.$touch()"
                    @blur="$v.invoiceForm.address.$touch()"
                  />
                  <v-text-field
                    v-model="invoiceForm.commune"
                    :class="breakpoint !== 'xs' ? 'invoice-form__input' : 'invoice-form__input-mobile'"
                    placeholder="Comuna"
                    background-color="white"
                    color="#3BADFF"
                    :error-messages="communeErrors"
                    filled
                    @input="$v.invoiceForm.commune.$touch()"
                    @blur="$v.invoiceForm.commune.$touch()"
                  />
                </template>

                <!-- Finalizar pago -->
                <span class="payment d-flex" @click="onPaymentClick">
                  <v-card v-if="currency==='CLP' && total !== 0"
                    :class="breakpoint !== 'xs' ? 'payment__logo pa-2': 'payment__logo-mobile pa-2'"
                  >
                    <v-img height="52.2px" max-width="80px" contain src="@/assets/images/logo-mercadopago.webp"></v-img>
                  </v-card>

                  <!-- Pagar con Mercadopago -->
                  <div
                    v-if="currency === 'CLP' && total !== 0"
                    class="payment__btn payment__btn--mercadopago grow"
                    dark
                  ></div>

                  <!-- Pagar con Paypal -->
                  <div
                    v-else-if="currency === 'USD' && total !== 0"
                    class="payment__btn payment__btn--paypal grow"
                    dark
                  ></div>

                  <!-- Cero pago -->
                  <v-btn
                    v-else-if="this.total === 0"
                    :class="breakpoint !== 'xs' ? 'payment__btn payment__btn--zero grow' : 'payment__btn-mobile payment__btn-mobile--zero grow'"
                    @click="onZeroPayClick"
                  >
                    OBTENER OFERTA
                  </v-btn>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <!-- Loading overlay -->
        <v-overlay :value="overlay" loading>
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
        </v-overlay>
      </v-col>
    </v-row>
    <div class="checkout-container"></div>

    <!-- Notificación -->
    <v-snackbar
      class="checkout-page__snackbar mt-16"
      v-model="snackbar.toggled"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      <v-icon>mdi-{{ snackbar.icon }}</v-icon>
      <span class="checkout-page__snackbar-text ml-2">{{ snackbar.text }}</span>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          v-bind="attrs"
          @click="snackbar.toggled = false"
          text
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { meta, validation, tools } from "@/libs/mixins";
import { packs } from "@/config/fixtures";

// Mercadopago init
let mp = new MercadoPago(process.env.VUE_APP_MERCADOPAGO_PUBLIC_KEY, {
    locale: "es-CL"
});

export default {
    name: "CheckoutPage",

    props: ["pack"],
    
    mixins: [meta, validation, tools],

    metaInfo() {
        return this.getMetaInfo({
            title: "Detalles de compra",
        });
    }, 

    data() {
        return {
            overlay: false,
            discountCode: "",
            document: {
                type: "invoice",
            },
            invoiceForm: {
                document: "invoice",
                businessName: "",
                rut: "",
                address: "",
                commune: "",
            },
            loading: false,
            snackbar: {
                text: "",
                timeout: 4000,
                toggled: false,
                color: "success",
            },
            totals: {
                subtotal: 0, 
                discount: {
                    amount: 0,
                },
            },
            uf: 0,
        };
    },
    created() {
        fetch("https://mindicador.cl/api").then(response =>{ return response.json(); }).then(data => { this.uf = Math.round(data.uf.valor); });
    },
    watch: {
        "invoiceForm.businessName"() {
            this.SET_INVOICE(this.invoiceForm);
            localStorage.setItem("invoiceRxData", JSON.stringify(this.invoiceForm));
        },
        "invoiceForm.rut"() {
            this.SET_INVOICE(this.invoiceForm);
            localStorage.setItem("invoiceRxData", JSON.stringify(this.invoiceForm));
        },
        "invoiceForm.address"() {
            this.SET_INVOICE(this.invoiceForm);
            localStorage.setItem("invoiceRxData", JSON.stringify(this.invoiceForm));
        },
        "invoiceForm.commune"() {
            this.SET_INVOICE(this.invoiceForm);
            localStorage.setItem("invoiceRxData", JSON.stringify(this.invoiceForm));
        },
        "document.type"(value) {
            if (value === "invoice") {
                this.invoiceForm = {
                    businessName: "",
                    rut: "",
                    address: "",
                    commune: "",
                };
                this.invoiceForm.document = value;
                this.SET_INVOICE(this.invoiceForm);
                localStorage.setItem("invoiceRxData", JSON.stringify(this.invoiceForm));
            } else {
                this.invoiceForm = {
                    businessName: "",
                    rut: "",
                    address: "",
                    commune: "",
                };
                this.invoiceForm.document = value;
                this.SET_INVOICE(this.invoiceForm);
                localStorage.setItem("invoiceRxData", JSON.stringify(this.invoiceForm));
            }
        }
    },
    computed: {
        ...mapState("payments", ["selectedPack", "currency"]),
        ...mapGetters("users", ["getUser"]),

        discountAmount() {
            return  this.totals.discount.amount;
        },
        iva() {
            let ivaAmount = ((this.selectedPack.totalPrice * this.uf) - this.discountAmount) * 0.19;
            return this.selectedPack.currencyCode === "CLP" ? ivaAmount : 0;
        },
        formattedTotals() {
            return {
                subtotal: this.formatCurrency(this.selectedPack.formattedTotalPrice * this.uf),
                iva: this.formatCurrency(this.iva),
                discount: this.formatCurrency(this.discountAmount),
                total: this.formatCurrency(this.total),
            };
        },
        total() {
            return this.currency === "CLP" 
                ? (this.selectedPack.totalPrice * this.uf) + this.iva - this.discountAmount
                : this.selectedPack.totalPrice - this.discountAmount;
        },
        businessNameErrors() {
            const errors = [];
            if (!this.$v.invoiceForm.businessName.$dirty) return errors;
            !this.$v.invoiceForm.businessName.required && errors.push("Campo requerido");
            return errors;
        },
        rutErrors() {
            const errors = [];
            if (!this.$v.invoiceForm.rut.$dirty) return errors;
            !this.$v.invoiceForm.rut.required && errors.push("Campo requerido");
            !this.$v.invoiceForm.rut.isValidRut && errors.push("RUT inválido");
            return errors;
        },
        addressErrors() {
            const errors = [];
            if (!this.$v.invoiceForm.address.$dirty) return errors;
            !this.$v.invoiceForm.address.required && errors.push("Campo requerido");
            return errors;
        },
        communeErrors() {
            const errors = [];
            if (!this.$v.invoiceForm.commune.$dirty) return errors;
            !this.$v.invoiceForm.commune.required && errors.push("Campo requerido");
            return errors;
        },
    },

    methods: {
        ...mapActions("payments", ["validateDiscount", "createPreference", "registerPayment", "cachePayment"]),
        ...mapActions("cookies", ["activity"]),
        ...mapMutations("payments", ["SET_PAYMENT_DATA", "SET_CURRENCY", "SET_SELECTED_PACK", "SET_INVOICE", "SET_DISCOUNT"]),

        createPaymentId(prefix) {
            let timestamp = new Date().getTime();
            return `${ prefix }${ timestamp }`;
        },
        formatAmount(amount) {
            return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatCurrency(amount) {
            let usdFormatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                currencyDisplay: "code",
            });
            let clpFormatter = new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
            });

            return this.currency === "CLP"
                ? clpFormatter.format(amount)
                : usdFormatter.format(amount);
        },
        onPaymentClick() {
            let paymentData = {
                externalReference: 1,
                data: {},
                form: {
                    ...this.invoiceForm,
                    document: this.document.type
                },
                method: "mercadopago"
            };
            this.cachePayment(paymentData);
            this.activity({
                path: this.$route.path,
                activity: "paymentAttempt",
            });
        },
        async onValidateDiscount() {
            this.loading = true;
            if (!this.discountCode || this.discountCode === "" || this.discountCode.length < 4) {
                this.showSnackBar("alert", "Debes agregar un código válido");
                this.loading = false;
                return;
            }
            try {
                // Validación código descuento
                let validationResponse = await this.validateDiscount({ discountCode: this.discountCode, packCode: this.selectedPack.packCode });
                
                if (validationResponse && validationResponse.discount) {
                    this.totals.discount.amount = (this.selectedPack.totalPrice * this.uf) * validationResponse.discount;
                    let discountedPrice = (this.selectedPack.totalPrice * this.uf) - ((this.selectedPack.totalPrice * this.uf) * validationResponse.discount);
                    if (this.currency === "CLP" && this.total !== 0) {
                        let preferenceData = {
                            name: this.selectedPack.name,
                            qty: 1,
                            unitPrice: Math.round(discountedPrice),
                            packCode: this.selectedPack.packCode,
                            discountCode: this.discountCode,
                        };
                        let preferenceResponse = await this.createPreference(preferenceData);
                        this.setMercadopagoButton(preferenceResponse.id);
                    }
                    this.loading = false;
                    this.showSnackBar("check-bold", "Cupón aplicado");
                } else {
                    this.totals.discount.amount = 0;
                    this.showSnackBar("alert", "Código inválido");
                }
            } catch (error) {
                console.error(error);
                this.totals.discount.amount = 0;
                this.showSnackBar("alert", error[1] || error[0] || "ERROR");
            }
        },
        async onZeroPayClick() {
            this.overlay = true;
            let { invoiceForm } = this;
            const paymentData = {
                paymentId: this.createPaymentId("free-"),
                invoiceForm,
                method: "free",
            };
            try {
                let registerResponse = await this.registerPayment(paymentData);
                this.$router.push("/payment-complete");
            } catch (error) {
                this.$router.push("/payment-complete");
                console.error(error);
            } finally {
                this.overlay = false;
            }
        },
        setMercadopagoButton(preferenceId) {
          
            if (document.getElementsByClassName("mercadopago-button")[0]) {
                document.getElementsByClassName("mercadopago-button")[0].remove();
            }

            mp.checkout({
                preference: {
                    id: preferenceId,
                },
                render: {
                    container: ".payment__btn",
                    label: "PAGAR",
                }
            });
        },
        setPaypalButton() {
            paypal.Buttons({
                createOrder: (data, actions) => {
                    return actions.order.create({
                        purchase_units: [{
                            amount: {
                                currency_code: "USD",
                                value: this.total,
                            }
                        }]
                    });
                },
                fundingSource: paypal.FUNDING.PAYPAL,
                onApprove: (data, actions) => {
                    this.overlay = true;
                    return actions.order.capture().then(async details => {
                        let paymentData = {
                            data: details,
                            form: {
                                ...this.invoiceForm,
                                document: "invoice",
                            },
                            method: "paypal",
                            paymentId: details.purchase_units[0].payments.captures[0].id,
                            status: "fail"
                        };
                        if (details.status === "COMPLETED") paymentData.status = "approved";
                        this.SET_PAYMENT_DATA(paymentData);
                        try {
                            const registerResponse = await this.registerPayment(paymentData);
                            this.$router.push("/payment-complete");
                            this.overlay = false;
                        } catch (error) {
                            // TODO: Manejar casos en que servicio registro falla
                            this.overlay = false;
                            console.error(error);
                            this.showSnackBar("alert", "Tuvimos un error registrando el pago");
                        }
                    });
                }
            }).render(".payment__btn--paypal");
        },
        showSnackBar(icon, text) {
            let color = icon === "alert" 
                ? "#CF6679"
                : "success";
            this.snackbar.icon = icon;
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.toggled = true;
        },
    },

    validations: {
        invoiceForm: {
            businessName: {
                required,
            },
            rut: {
                required,
                isValidRut: validation.methods.isValidRut,
            },
            address: {
                required,
            },
            commune: {
                required,
            },
        }
    },
            
    beforeMount() {
        ////// TODA ESTA LOGICA DEBERIA VOLAR Y SOLO TOMARSE PARAMETROS POR PROPS //////
        if (this.pack) {
            let pack = {};
            /// Logica para leer pack desde props //
            let clpFormatter = new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
            });
            
            packs.forEach((p) => {
                if (p.packCode == this.pack) {
                    pack = {
                        formattedTotalPrice: clpFormatter.format(p.price.clp * p.qty * this.uf, 0),
                        packCode: p.packCode,
                        name: p.name,
                        qty: p.qty,
                        totalPrice: p.price.clp * p.qty * this.uf,
                        unitPrice: p.price.clp * this.uf,
                        currencyCode: p.currencyCode,
                    };
                }
            });

            if (!pack.packCode) {
                console.error("No se pudo asociar un pack:" + packCode + " a packs disponibles");
            }

            /// Se agregan parametros hacia vuex pasados por linea de comando ///
            this.SET_CURRENCY("CLP"); // se utiliza CLP por defecto, agregar otro parametro this.currency 
            this.SET_SELECTED_PACK(pack);
        }
        ////////////////////////
        
        // Logica solo para volver a checkout si no estas registrado! 
        // ¡¡¡¡¡¡NO BORRAR, A MENO QUE PRUEBEN SI FUNCIONA EL VOLVER A CHECKOUT DESDE UN REGISTRO!!!!!
        const packParameter = JSON.parse(localStorage.getItem("checkout_params"));
        if (packParameter && packParameter.currency && packParameter.pack) {
            this.SET_CURRENCY(packParameter.currency);
            this.SET_SELECTED_PACK(packParameter.pack);
            localStorage.removeItem("checkout_params");
        }

        if (!this.selectedPack) {
            // Si se llega a ruta sin pack seleccionado, volver a /pricing
            this.$router.push("/pricing");
        }
        this.SET_DISCOUNT("");
        localStorage.removeItem("invoiceRxData");
    },

    async mounted() {
        if (this.currency === "CLP") {
            try {
                let pack = {};
                let uf = await fetch("https://mindicador.cl/api").then(response =>{ return response.json(); }).then(data => { return Math.round(data.uf.valor); });
                packs.forEach((p) => {
                    if (p.packCode == this.selectedPack.packCode) {
                        pack = {
                            packCode: p.packCode,
                            name: p.name,
                            qty: p.qty,
                            totalPrice: Math.round(p.price.clp * p.qty * uf * 1.19),
                            unitPrice: p.price.clp * uf,
                            currencyCode: p.currencyCode,
                        };
                    }
                });
                console.log(pack);
                let preferenceResponse = await this.createPreference(pack);
                this.setMercadopagoButton(preferenceResponse.id);
            } catch (error) {
                console.error(error);
            }
        } else if (this.currency === "USD") {
            try {
                this.invoiceForm = {
                    ...this.invoiceForm,
                    item: this.selectedPack,
                };
                this.setPaypalButton();
            } catch (error) {
                console.error(error);
            }
        } else {
            return;
        }
    },
};
</script>
